import { injectHead } from "@vueuse/head";
import { InferSeoMetaPlugin } from "@unhead/addons";
import { defineNuxtPlugin, useRuntimeConfig } from "#app";
import { ogDescriptionTemplate, ogTitleTemplate, resolveAliases, seoOptimise } from "#nuxt-unhead/config";
const resolveAliasProps = ["href", "src"];
function processRuntimeConfigTokens(s, config) {
  const replacer = (preserveToken) => (_, token) => {
    if (token === "pageTitle" || token === "s")
      return "%s";
    let val;
    if (token.includes(".")) {
      val = token.split(".").reduce((acc, key) => acc[key] || {}, config);
    } else {
      val = config[token];
    }
    return val || (preserveToken ? token : "");
  };
  let template = s.replace(/%(\w+\.?\w+)%/g, replacer()).replace(/%(\w+\.?\w+)/g, replacer(true)).trim();
  if (config.titleSeparator) {
    if (template.endsWith(config.titleSeparator))
      template = template.slice(0, -config.titleSeparator.length).trim();
    if (template.startsWith(config.titleSeparator))
      template = template.slice(config.titleSeparator.length).trim();
  }
  return template;
}
export default defineNuxtPlugin(() => {
  const head = injectHead();
  const config = useRuntimeConfig().public;
  if (!head)
    return;
  if (seoOptimise) {
    head.use(
      InferSeoMetaPlugin({
        robots: false,
        ogTitle: processRuntimeConfigTokens(ogTitleTemplate, config),
        ogDescription: processRuntimeConfigTokens(ogDescriptionTemplate, config)
      })
    );
  }
  head.hooks.hook("tag:normalise", async ({ tag }) => {
    if (["titleTemplate", "title"].includes(tag.tag) && typeof tag.children === "string")
      tag.children = processRuntimeConfigTokens(tag.children, config);
    if (tag.tag === "meta" && typeof tag.props.content === "string")
      tag.props.content = processRuntimeConfigTokens(tag.props.content, config);
  });
  if (config.titleSeparator) {
    head.hooks.hook("tags:resolve", async ({ tags }) => {
      for (const tag of tags) {
        if (tag.tag === "title" && tag.children) {
          tag.children = tag.children.trim();
          if (tag.children.endsWith(config.titleSeparator))
            tag.children = tag.children.slice(0, -config.titleSeparator.length).trim();
          if (tag.children.startsWith(config.titleSeparator))
            tag.children = tag.children.slice(config.titleSeparator.length).trim();
        }
      }
    });
  }
  if (resolveAliases) {
    head.hooks.hook("tags:resolve", async (ctx) => {
      const validTags = [];
      for (const tag of ctx.tags) {
        let isValid = true;
        for (const prop of resolveAliasProps) {
          if (!tag.props[prop] || !(tag.props?.[prop] && /^[~@]+\//.test(tag.props[prop])))
            continue;
          if (process.server) {
            let moduleUrl = tag.props[prop];
            try {
              moduleUrl = (await import(
                /* @vite-ignore */
                `${tag.props[prop]}?url`
              )).default;
            } catch (e) {
            }
            tag.props[prop] = moduleUrl;
          } else {
            isValid = false;
          }
        }
        if (isValid)
          validTags.push(tag);
      }
      ctx.tags = validTags;
    });
  }
});
